module.exports = __webpack_public_path__ + "img/cli_12.963a0798.png";